import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ContactComponent } from '@pages/contact/contact.component';

@Injectable({
    providedIn: 'root',
})
export class ConfirmLeaveGuard
    implements CanDeactivate< ContactComponent>
{
    canDeactivate(component: ContactComponent) {
        return component.canDeactivate();
    }
}
